import gsap, { Linear } from 'gsap';

export const createLoopingTicker = (
  elements: Array<HTMLElement>,
  container: HTMLElement,
  speed: number = 3,
): gsap.core.Timeline => {
  const masterTimeline = gsap.timeline({ repeat: -1 });

  const timeline = gsap.timeline({ paused: true });
  let totalWidth = 0;
  const containerWidth = container.offsetWidth || 0;

  elements.forEach((element) => {
    totalWidth += element?.offsetWidth || 0;
  });

  let nextStartPosition = 0;
  let firstItemDuration = 0;
  let cycleDuration = 0;
  new Array(3).fill(0).forEach((value, loopIndex) => {
    nextStartPosition = 0;
    elements.forEach((element, index) => {
      const width = element?.offsetWidth || 0;
      const startPosition = nextStartPosition;
      const pixelsPerSecond = speed * Math.min(100, Math.max(30, containerWidth * 0.1));

      const fromPosition = containerWidth - startPosition;
      const endPosition = -width - startPosition;

      const distance = Math.abs(endPosition - fromPosition);
      const duration = distance / pixelsPerSecond;
      const position = (startPosition + totalWidth * loopIndex) / pixelsPerSecond;

      nextStartPosition = (element?.offsetLeft || 0) + width;

      timeline.fromTo(
        element,
        {
          x: `${(fromPosition / width) * 100}%`,
        },
        {
          duration,
          ease: 'none',
          x: `${(endPosition / width) * 100}%`,
        },
        position,
      );

      if (index === 0 && loopIndex === 0) {
        firstItemDuration = Math.abs(fromPosition - startPosition) / pixelsPerSecond; // timeline.duration();
      }
    });

    if (loopIndex === 0) {
      cycleDuration = timeline.duration();
    }
  });

  masterTimeline.fromTo(
    timeline,
    {
      time: cycleDuration,
    },
    {
      time: `+=${cycleDuration - firstItemDuration}`,
      duration: cycleDuration - firstItemDuration,
      ease: Linear.easeNone,
    },
  );

  return masterTimeline;
};

export const createTimelineSequence = (
  timelines: Array<gsap.core.Timeline>,
  spacing: number,
  timeline?: gsap.core.Timeline,
): gsap.core.Timeline => {
  let sequence!: gsap.core.Timeline;

  if (!timeline) {
    sequence = gsap.timeline({ paused: true });
  } else {
    sequence = timeline;
  }

  timelines.forEach((animation, i) => {
    sequence.add(animation, i * spacing);
  });

  return sequence;
};

export const createLoopingTimeline = (
  timelines: Array<gsap.core.Timeline>,
  spacing: number = 0.2,
): gsap.core.Timeline => {
  const timeline = gsap.timeline({
    paused: true,
    repeat: -1,
    onReverseComplete: () => {
      timeline.totalTime(timeline.rawTime() + timeline.duration() * 100);
    },
  });

  const sequence = gsap.timeline({ paused: true });
  const cycleDuration = spacing * timelines.length;
  let duration: number = 0;

  timelines
    .concat(timelines)
    .concat(timelines)
    .forEach((timeline, i) => {
      sequence.add(timeline, i * spacing);
      duration = duration || timeline.duration();
    });

  timeline.fromTo(
    sequence,
    {
      time: cycleDuration + duration / 2,
    },
    {
      time: `+=${cycleDuration}`,
      duration: cycleDuration,
      ease: Linear.easeNone,
    },
  );

  return timeline;
};
